import {useCSS} from '@pinecast/styles';
import type * as React from 'react';

/**
 * The heading of a step of the tip flow: asking for an email, saying that the
 * email is on its way, saying that a subscription changed.
 *
 * Continue takes the whole form away, and its button with it. Focus recovery
 * (`FocusRecoveryProvider`) then puts focus on the nearest bare
 * `data-focus-fallback`, which is this heading, so a screen reader reads the
 * step that is now open (WCAG 2.4.3). The page itself moves no focus.
 *
 * It looks like the other questions of the page (`TipFrequency`'s heading).
 */
const StepHeading = ({
  centered = false,
  children,
}: {
  centered?: boolean;
  children: React.ReactNode;
}) => {
  const css = useCSS();
  return (
    <h2
      className={css({
        fontFamily: 'Monument Grotesk Bold',
        fontSize: '18px',
        fontWeight: 400,
        lineHeight: '24px',
        margin: '0 0 12px',
        textAlign: centered ? 'center' : undefined,
      })}
      data-focus-fallback
    >
      {children}
    </h2>
  );
};

export default StepHeading;
